import './Footer.css'

export default function Footer() {
    return (
        <footer>
            <p>SilverOnyx &copy; 2022</p>
            <div>
                <h3>HEADQUARTERS</h3>
                <p>16171 S. Bringhurst Blvd.</p>
                <p>Suite 100</p>
                <p>Bluffdale, Utah 84065</p>
            </div>
        </footer>
    )
}


